class CustomLikeList {
  constructor(selector, rootElement = document) {
    rootElement.querySelectorAll(selector).forEach((element) => {
      element.addEventListener('click', (e) => {
        this.fetchLikesData(e.currentTarget);
      });
    });
  }

  async fetchLikesData(element) {
    const [likeableType, likeableId] = element.id.split('-');
    const targetElementId = `#${likeableType}_${likeableId}`;
    const requestUrl = `${location.origin}/likes.json`;
    const bodyParam = {
      likeable_type: likeableType,
      likeable_id: likeableId,
    };
    const query = new URLSearchParams(bodyParam);

    try {
      const response = await fetch(`${requestUrl}?${query}`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const data = await response.json();
      this.renderLikesList(data, targetElementId);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  renderLikesList(data, targetElementId) {
    $(targetElementId).find('.c-like-list--item').remove();
    $('.reaction-tabs').empty();

    const sortedReactions = data.sort(
      (a, b) => b.users.length - a.users.length
    );
    const normalReaction = sortedReactions.find(
      (reaction) => !reaction.community_reaction
    );

    this.renderUsers(data, 'all', targetElementId);
    this.renderNormalLikesTab(normalReaction, targetElementId);
    this.renderReactionTabs(sortedReactions);
    this.attachTabClickHandler(data, targetElementId);
  }

  renderNormalLikesTab(normalReaction, targetElementId) {
    const normalLikesTab = $(`${targetElementId}_normal_like_tab`);

    if (normalReaction) {
      normalLikesTab.find('span').text(`${normalReaction.users.length}`);
    } else {
      normalLikesTab.remove();
    }
  }

  renderReactionTabs(sortedReactions) {
    sortedReactions.forEach((reaction, index) => {
      if (reaction.community_reaction) {
        this.appendReactionTab(
          reaction.community_reaction,
          reaction.users.length
        );
      }
    });
  }

  appendReactionTab(communityReaction, usersCount) {
    const { url_name, title, image_url } = communityReaction;
    const tab = `
      <div class="js-like-tab like-tab relative flex flex-col font-bold text-sm mt-4 cursor-pointer whitespace-nowrap" data-tab="${url_name}" id="${url_name}">
        <div class="flex items-center px-4 border-0 border-r border-solid border-gray-200">
          <img src="${image_url}" alt="${title}" class="w-4 h-4 mr-1">
          <span>${usersCount}</span>
        </div>
        <div class="h-4"></div>
      </div>
    `;
    $('.reaction-tabs').append(tab);
  }

  attachTabClickHandler(data, targetElementId) {
    $('.js-like-tab').on('click', (event) => {
      $('.like-tab').removeClass('active');
      $(event.currentTarget).addClass('active');
      const selectedTab = $(event.currentTarget).data('tab');
      this.renderUsers(data, selectedTab, targetElementId);
    });
  }

  renderUsers(data, selectedTab, targetElementId) {
    $(targetElementId).find('.c-like-list--item').hide();

    switch (selectedTab) {
      case 'all':
        data.forEach((reaction) => {
          reaction.users.forEach((user) => {
            if (reaction.community_reaction) {
              this.renderUserItem(
                user,
                targetElementId,
                reaction.community_reaction.image_url
              );
            } else {
              this.renderUserItem(user, targetElementId);
            }
          });
        });
        break;

      case 'normal_likes':
        const normalReaction = data.find(
          (reaction) => !reaction.community_reaction
        );
        if (normalReaction) {
          normalReaction.users.forEach((user) => {
            this.renderUserItem(user, targetElementId);
          });
        }
        break;

      default:
        const selectedReaction = data.find(
          (reaction) =>
            reaction.community_reaction &&
            reaction.community_reaction.url_name === selectedTab
        );
        if (selectedReaction) {
          selectedReaction.users.forEach((user) => {
            this.renderUserItem(
              user,
              targetElementId,
              selectedReaction.community_reaction.image_url
            );
          });
        }
        break;
    }
  }

  renderUserItem(user, targetElementId, reaction_image_url) {
    const userId = user.url_name;
    const existingItem = $(targetElementId).find(
      `.c-like-list--item[data-user-id="${userId}"]`
    );

    if (existingItem.length) {
      existingItem.show();
    } else {
      const userItem = this.createUserItem(
        user,
        reaction_image_url,
        targetElementId
      );
      $(targetElementId).find('.c-like-list--modal__body').append(userItem);
    }
  }

  createUserItem(user, reaction_image_url, targetElementId) {
    const { nickname, url, avatar_url, discard } = user;

    const userItem = document.createElement('div');
    userItem.classList.add('c-like-list--item');
    userItem.setAttribute('data-user-id', user.url_name);

    const userInfo = document.createElement('div');
    userInfo.classList.add('c-like-list--info');

    const reactionElement = this.createReactionElement(
      reaction_image_url,
      targetElementId
    );
    const avatarElement = this.createAvatarElement(avatar_url, user);
    const nicknameElement = this.createNicknameElement(
      nickname,
      url,
      user,
      discard
    );

    userInfo.appendChild(reactionElement);
    userInfo.appendChild(avatarElement);
    userInfo.appendChild(nicknameElement);
    userItem.appendChild(userInfo);

    return userItem;
  }

  createReactionElement(reactionImageUrl = '', targetElementId) {
    const normalLikeImagePath = document.querySelector(
      `${targetElementId}_normal_like_icon`
    ).innerHTML;

    const reactionElement = reactionImageUrl
      ? document.createElement('img')
      : document.createElement('div');
    if (reactionImageUrl) {
      reactionElement.src = reactionImageUrl;
      reactionElement.classList.add('w-6', 'h-6', 'mr-2', 'rounded-full');
    } else {
      reactionElement.innerHTML = normalLikeImagePath;
      reactionElement.classList.add(
        'w-6',
        'h-6',
        'mr-2',
        'rounded-full',
        'bg-[#E7E8E7]',
        'p-1',
        'flex',
        'items-center'
      );
    }

    return reactionElement;
  }

  createAvatarElement(avatarUrl, user) {
    const avatarElement = document.createElement('div');
    avatarElement.classList.add('c-like-list--avatar');

    const avatarImage = document.createElement('img');
    avatarImage.src = avatarUrl;
    avatarImage.alt = 'ユーザー画像';

    if (user.discard) {
      avatarElement.appendChild(avatarImage);
    } else {
      const userLink = document.createElement('a');
      userLink.href = user.url;
      userLink.classList.add('p-post-user__avatar');
      userLink.appendChild(avatarImage);

      const avatarBadge = user.equiped_badges.find(
        (badge) => badge.position === 'avatar'
      );
      if (avatarBadge) {
        const badgeImage = document.createElement('img');
        badgeImage.src = avatarBadge.image_url;
        badgeImage.classList.add('p-post-user-avatar__badge-image');
        badgeImage.alt = 'バッジ画像';
        userLink.classList.add('--with-badge');
        userLink.appendChild(badgeImage);
      }

      avatarElement.appendChild(userLink);
    }

    return avatarElement;
  }

  createNicknameElement(nickname, url, user, discard) {
    const nicknameElement = document.createElement('div');
    nicknameElement.classList.add('c-like-list--user');

    const nicknameText = document.createElement('span');
    nicknameText.classList.add('c-like-list--user__name');
    nicknameText.textContent = nickname;

    if (discard) {
      nicknameElement.appendChild(nicknameText);
    } else {
      const userLink = document.createElement('a');
      userLink.href = url;
      userLink.classList.add('c-like-list__nickname');
      userLink.appendChild(nicknameText);

      const badgeImage = this.createNicknameBadgeImage(user);
      if (badgeImage) {
        userLink.appendChild(badgeImage);
      }

      nicknameElement.appendChild(userLink);
    }

    return nicknameElement;
  }

  createNicknameBadgeImage(user) {
    let badgeImage = null;

    if (user.image_badge_url) {
      badgeImage = document.createElement('img');
      badgeImage.src = user.image_badge_url;
      badgeImage.classList.add('c-like-list-nickname__badge-image');
    } else {
      const nicknameBadge = user.equiped_badges.find(
        (badge) => badge.position === 'nickname'
      );
      if (nicknameBadge) {
        badgeImage = document.createElement('img');
        badgeImage.src = nicknameBadge.image_url;
        badgeImage.classList.add('c-like-list-nickname__badge-image');
        badgeImage.alt = 'バッジ画像';
      }
    }

    return badgeImage;
  }
}

export { CustomLikeList };
